import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconPlay",
  "use": "IconPlay-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"IconPlay\"><path d=\"M8 16a8 8 0 10-8-8 8.009 8.009 0 008 8zm3.208-7.667a.626.626 0 01-.391.55L6.76 10.91a.79.79 0 01-.354.088.612.612 0 01-.325-.09.688.688 0 01-.306-.608V6.364a.65.65 0 01.985-.61l4.057 2.03a.626.626 0 01.391.55z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol